import { Heading, Row, StatusTag } from "./Primitives";

/**
 * Shared readme-style detail view.
 * Works for both a completed project (has status + link) and an
 * ongoing project (has progress instead).
 */
export default function ReadmeOutput({ item }) {
  return (
    <div>
      <Heading>{item.name}/README.md</Heading>
      <div className="space-y-0.5 mb-3">
        <Row label="tech">{item.tech.join(", ")}</Row>
        {item.status && (
          <Row label="status">
            <StatusTag status={item.status} />
          </Row>
        )}
        {item.progress && <Row label="progress">{item.progress}</Row>}
        {item.link && (
          <Row label="link">
            <a href={item.link} target="_blank" rel="noreferrer" className="text-sky-400 hover:underline">
              {item.link}
            </a>
          </Row>
        )}
      </div>
      {item.readme.map((line, i) => (
        <div key={i} className="text-neutral-300">{line || "\u00A0"}</div>
      ))}
    </div>
  );
}